import usePagination from '@/hooks/usePagination';
import { BadgeFilters, BadgeType, PaginationProps } from '@/types/schema';

import { useBadgeTemplatesQuery } from '../graphql/queries/generated/badgeTemplates';

function useBadgeTemplates({
  filters,
  paginationProps = {},
  pause,
}: {
  filters: BadgeFilters;
  paginationProps?: PaginationProps;
  pause?: boolean;
}) {
  const { data, isFetchingMore, error, refetch, fetchMore, isFetching, totalCount } = usePagination(
    useBadgeTemplatesQuery,
    {
      input: { filters, paginationProps },
    },
    {
      edgeKey: 'badges',
      pause,
    },
  );

  return {
    initialFetching: isFetching,
    isFetchingMore,
    error,
    badges: data as BadgeType[],
    totalCount,
    refetch,
    fetchMore,
  };
}

export default useBadgeTemplates;
